/** Which tab is allowed to emit preview audio. */
export function shouldOutputPreviewAudio(s: {
  layout: { id: string };
  isLeader: boolean;
  connectedTabs: readonly unknown[];
}): boolean {
  // Color Suite never plays sound — keeps one AudioContext on the editor
  if (s.layout.id === 'color-suite') return false;
  // Primary editor always owns audio when open (even if momentarily not leader)
  if (s.layout.id === 'primary') return true;
  return s.isLeader || s.connectedTabs.length <= 1;
}
